<template>
  <div
    :class="[
      $style.badge,
      $style[`variant-${variant}`]
    ]"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: 'BaseBadge',
  props: {
    variant: {
      type: String,
      default: 'orange',
    },
  },
}
</script>

<style module lang="scss">
  @import '../../assets/scss/variables';
  .badge {
    border-radius: .35rem;
    font-size: $font-size-small;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: .25rem 1rem;
    &.variant-orange {
      background-color: $color-benihi-red;
      color: $color-white;
    }
    &.variant-orange-outline {
      border: 2px solid $color-benihi-red;
      color: $color-benihi-red;
    }
    &.variant-gray {
      background-color: $color-brainstem-grey;
      color: $color-bleached-silk;
    }
    &.variant-light-gray {
      background-color: $color-bleached-silk;
      color: $color-tomato;
    }
    &.variant-green {
      background-color: $color-bubble-bobble-green;
      color: $color-white;
    }
    &.variant-green-outline {
      border: 2px solid $color-bubble-bobble-green;
      color: $color-bubble-bobble-green;
    }
    &.variant-black-outline {
      border: 2px solid $color-carbon;
      color: $color-carbon;
    }
  }
</style>
